import styled from 'styled-components/macro';

const ScoreTitle = styled.span`
  font-weight: 2rem;
  font-weight: bold;
  letter-spacing: 0.2rem;
`;

export default ScoreTitle;
